// extracted by mini-css-extract-plugin
export var attachment = "_ne-a";
export var emailContainer = "_ne-4";
export var emailContentPaddedContainer = "_ne-b";
export var emailHeader = "_ne-6";
export var emailIframe = "_ne-3";
export var emailInfoIcon = "_ne-9";
export var emailShortenedSummary = "_ne-e";
export var infoDropdown = "_ne-0";
export var infoRowBoundedContent = "_ne-d";
export var internal = "_ne-5";
export var merchant = "_ne-8";
export var messageInputContainer = "_ne-h";
export var normal = "_ne-7";
export var replyCard = "_ne-f";
export var subtleButton = "_ne-1";
export var subtleButtonIconContainer = "_ne-2";
export var toggleViewRepliesButton = "_ne-c";
export var wrappingText = "_ne-g";